import { requst } from '../config'

// 获取报表文件列表
export const getReportDocListApi = projectId => {
    const url = `/setting/report/listAll?projectId=${projectId}`
    return requst.get(url)
}

// 获取streamer报表文件列表
export const getReportStreamerDocListApi = projectId => {
    const url = `/setting/report/listAll?projectId=${projectId}`
    return requst.get(url)
}

//
export const getSureReportListApi = projectId => {
    const url = `/monitor/dailyStatus/list/${projectId}`
    return requst.get(url)
}

// 获取当前报表参数列表
export const getReportDocAllParApi = id => {
    const url = `/report/doc/getDocAllPars/${id}`
    return requst.get(url)
}

/* 下载 OBN 文件 */
export const downOBNReportDocApi = url => {
    return requst.get(
        url,
        {
            responseType: 'blob',
        }
    )
}

/* 下载拖缆文件 */
export const downStreamerReportApi = params => {
    const url = `/webroot/decision/view/report?viewlet=Streamer%2BDaily%2BReport.cpt&op=write&endDate=${params.date}&projectId=${params.projectId}&format=plugin_docx`
    return requst.post(
        url,
        { ...params },
        {
            responseType: 'blob',
        }
    )
}

// 获取当前报表参数列表
export const getFineLogin = () => {
    const url = `/fine/loginForDownloadReport`
    return requst.get(url)
}

// 新增报表
export const addReportApi = params => {
    const url = `/setting/report`
    return requst.post(url, { ...params })
}

// 编辑报表
export const editReportApi = params => {
    const url = `/setting/report`
    return requst.put(url, { ...params })
}

// 删除报表
export const deleteReportApi = id => {
    const url = `/setting/report/${id}`
    return requst.delete(url)
}
